import {StoreItemCategory} from '../../../../shared/entity_datas/StoreEnums'
import {UIWStoreBodyController} from './UIWStoreBodyController'
import {ColonistCoinProduct} from '../../../../shared/store/ColonistCoinProduct'
import {UIDCoinProductView} from './UIDCoinProductView'
import {createDivIn, createHeaderIn, createImgIn, createLinkIn, createParagraphIn, setElementInnerHTML, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import * as Item from '../../../../shared/store/StoreItemList'
import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct'
import {UIDStoreMembershipProductView} from './UIDStoreMembershipProductView'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIPopupController} from '../../../shared/scripts/ui_popup/UIPopupController'
import {TranslationObject} from '@colonist/i18n'
import {ColonistMembershipType, LobbyImage} from '@colonist/types'
import {DiscordInstance} from '../discord/DiscordInstance'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes'
import {UIStoreItemView} from './UIStoreItemView'
import {PaymentMethod} from '../../../../shared/store/BaseColonistStoreProduct'
import {UIDStoreMembershipTabsController} from '../../../shared/scripts/store/UIDStoreMembershipTabsController'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {getManageSubscriptionPopupBody} from '../../../shared/scripts/store/StoreUtils'
import {UIDStoreGiftOverlayController} from './UIDStoreGiftOverlayController'
import {UIAjaxWrapper} from '../../../shared/scripts/network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../../shared/scripts/network/UIAPIEndpoints'
import {ReferralProgram, ReferralReward} from '../../../../shared/ReferralProgram'
import {BaseStoreItem} from '../../../../shared/store/BaseStoreItem'
import {clientI18n} from '../../../shared/scripts/ClientI18n'
import {ReferralTypeEnum} from '../../../../shared/entity_datas/EntityDatas'
import {AudioManager, AudioType} from '@colonist/audio'

export class UIDStoreBodyController extends UIWStoreBodyController {
    protected override createGiftOverlay() {
        const sceneContainer = document.getElementById('scene_discord_gifting_container') as HTMLDivElement
        this.giftOverlayController = new UIDStoreGiftOverlayController(sceneContainer, this.storeState)
    }

    // eslint-disable-next-line class-methods-use-this
    protected override createMembershipItems() {
        this.membershipsDiv.replaceChildren()
        this.membershipItems.length = 0
        const membershipProducts = ColonistMembershipProduct.getAllMembershipProducts()
        for(const product of membershipProducts) {
            const giftOverlay = UIUtilsEjsVariables.isUserOnDiscordMobile ? undefined : this.giftOverlayController
            const membership = new UIDStoreMembershipProductView(this.membershipsDiv, this.storeState, product, giftOverlay)
            this.membershipItems.push(membership)
        }
        this.membershipTabsController = new UIDStoreMembershipTabsController(this.storeState)
        // To avoid the element occupy the whole width
        createDivIn(this.membershipsDiv, '')
    }

    protected override async updateReferralProgram() {
        this.referralSection.classList.remove('hidden')
        this.referralSidebarButton.classList.remove('hidden')

        const userReferralCount = await UIDStoreBodyController.getUserReferralCount()

        this.referralInfoDiv.replaceChildren()
        this.referralItemsDiv.replaceChildren()

        createParagraphIn(this.referralInfoDiv, {key: 'strings:storePage.sections.referral.description', options: {referralCount: userReferralCount, context: userReferralCount == 1 ? 'one' : 'other'}}, '', '')

        this.loadReferralProgramDetails(userReferralCount)
    }

    protected override updateAllCategoryItems() {
        this.items.length = 0
        this.updateCategoryItems(StoreItemCategory.Expansion, this.expansionsDiv)
        this.updateCategoryItems(StoreItemCategory.Map, this.mapsDiv)
        this.updateCategoryItems(StoreItemCategory.Color, this.colorsDiv)
        this.updateCategoryItems(StoreItemCategory.Icon, this.avatarsDiv)

        if(UIUtilsEjsVariables.isUserOnDiscordMobile) {
            this.setUnavailableOnMobileActions()
            return
        }

        if(ClientUserState.userState?.forceSubscription === false) return
        this.setSubscribeClickActions()
    }

    override updateOwnedMembership(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined): void {
        this.createMembershipItems()
        if(ownedMembership == undefined) return

        const disableMembershipManagement = (paymentMethod != PaymentMethod.Discord) && (paymentMethod != PaymentMethod.Stripe)
        for(const membershipView of this.membershipItems) {
            if(disableMembershipManagement) {
                if(membershipView.membershipProduct.type == ownedMembership.type) {
                    membershipView.changeToOwnedButton()
                    continue
                }
                membershipView.removeButton()
                continue
            }

            membershipView.changeToManageButton()
        }
    }

    override updateSubscribedItems(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined): void {
        if(ownedMembership == undefined) return
        switch(ownedMembership.type) {
            case ColonistMembershipType.PlusMonthly:
            case ColonistMembershipType.PlusYearly:
                this.markItemsAsManageSubscription(StoreItemCategory.Map)
                this.markItemsAsManageSubscription(StoreItemCategory.Expansion)
                this.markItemsAsManageSubscription(StoreItemCategory.Color)
                break
            case ColonistMembershipType.Holiday2023AllAccessPass:
            case ColonistMembershipType.PremiumMonthly:
            case ColonistMembershipType.PremiumYearly:
                this.markItemsAsSubscribed(StoreItemCategory.Map)
                this.markItemsAsSubscribed(StoreItemCategory.Expansion)
                this.markItemsAsManageSubscription(StoreItemCategory.Color)
                break
            case ColonistMembershipType.EliteMonthly:
            case ColonistMembershipType.EliteYearly:
                this.markItemsAsSubscribed(StoreItemCategory.Map)
                this.markItemsAsSubscribed(StoreItemCategory.Expansion)
                this.markItemsAsSubscribed(StoreItemCategory.Color)
                break
        }
    }

    protected override markItemsAsSubscribed(category: StoreItemCategory) {
        for(const item of this.items) {
            if(!UIDStoreBodyController.shouldUpdateItemView(item)) continue
            if(item.itemDetail.category != category) continue

            item.markAsSubscribed()
            item.updateAction(() => {
                UIDStoreBodyController.showSubscribedItemPopup()
            })
        }
    }

    private markItemsAsManageSubscription(category: StoreItemCategory) {
        for(const item of this.items) {
            if(!UIDStoreBodyController.shouldUpdateItemView(item)) continue
            if(item.itemDetail.category != category) continue

            item.updateAction(() => {
                UIDStoreBodyController.showManageSubscriptionOnWebPopup()
            })
        }
    }

    protected override createCoinProducts() {
        const coinProducts = ColonistCoinProduct.getAllCoinProducts()
        for(const product of coinProducts) {
            new UIDCoinProductView(this.coinsDiv, product)
        }
    }

    private setSubscribeClickActions() {
        for(const item of this.items) {
            if(!UIDStoreBodyController.shouldUpdateItemView(item)) continue

            if(item.itemDetail.category == StoreItemCategory.Color) {
                item.updateAction(() => {
                    void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.EliteMonthly)
                })
                continue
            }

            item.updateAction(() => {
                void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.PremiumMonthly)
            })
        }
    }

    private setUnavailableOnMobileActions() {
        for(const item of this.items) {
            if(!UIDStoreBodyController.shouldUpdateItemView(item)) continue

            item.updateAction(() => {
                UIDStoreBodyController.showUnavailableOnMobilePopup()
            })
        }
    }

    private static shouldUpdateItemView(itemView: UIStoreItemView): boolean {
        const isItemOwned = itemView.isMarkedOwned
        if(isItemOwned) return false

        const isBlackColor = itemView.itemDetail.name.key === new Item.SIColorBlack().name.key
        if(isBlackColor) return false

        const isItemAnIcon = itemView.itemDetail.category === StoreItemCategory.Icon
        if(isItemAnIcon) return false

        return true
    }

    private static showComingSoonPopup() {
        const popupTitle: TranslationObject = {key: 'strings:popups.comingSoon.title'}
        const popupBody: TranslationObject = {key: 'strings:popups.comingSoon.body', options: {context: 'membership'}}
        UIPopupController.createSimplePopup(popupTitle, popupBody)
    }

    static showUnavailableOnMobilePopup() {
        const popupTitle: TranslationObject = {key: 'strings:popups.unavailableOnMobile.title'}
        const popupBody: TranslationObject = {key: 'strings:popups.unavailableOnMobile.body'}
        UIPopupController.createSimplePopup(popupTitle, popupBody)
    }

    private static showSubscribedItemPopup() {
        const popupTitle: TranslationObject = {key: 'strings:storePage.subscribedItem.title'}
        const popupBody: TranslationObject = {key: 'strings:storePage.subscribedItem.body'}
        UIPopupController.createSimplePopup(popupTitle, popupBody)
    }

    private static showManageSubscriptionOnWebPopup() {
        const popupTitle: TranslationObject = {key: 'strings:storePage.manageMembership.title'}
        const popupBody: TranslationObject = getManageSubscriptionPopupBody()
        UIPopupController.createSimplePopup(popupTitle, popupBody)
    }

    private static async getUserReferralCount(): Promise<number> {
        const data = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiGetUserReferralCount(), undefined)
        return data?.json?.referralCount ?? 0
    }

    private loadReferralProgramDetails(userReferralCount: number) {
        const referralProgram = ReferralProgram.referralRewardLevels
        referralProgram.forEach((referralReward: ReferralReward) => {
            const {contentDiv, headerDiv, bodyDiv} = this.createBaseView()
            const button = UIDStoreBodyController.createButton(contentDiv, referralReward, userReferralCount)
            const image = UIDStoreBodyController.createTitleAndImage(headerDiv, bodyDiv, referralReward)
            const description = UIDStoreBodyController.createDescription(bodyDiv, referralReward)
            UIDStoreBodyController.addClickEventListener(contentDiv, description, image)
            UIDStoreBodyController.addButtonOnClickBehavior(button, userReferralCount, referralReward)
        })
    }

    private createBaseView(): {contentDiv: HTMLDivElement, headerDiv: HTMLDivElement, bodyDiv: HTMLDivElement} {
        const contentDiv = createDivIn(this.referralItemsDiv, 'store_page_item')
        const headerDiv = createDivIn(contentDiv, 'store_page_item_header')
        const bodyDiv = createDivIn(contentDiv, 'store_page_item_body')
        return {contentDiv: contentDiv, headerDiv: headerDiv, bodyDiv: bodyDiv}
    }

    private static createButton(contentDiv: HTMLDivElement, referralReward: ReferralReward, userReferralCount: number): HTMLLinkElement {
        const button = createLinkIn(contentDiv, '#', {key: 'strings:colonistCommon.utils.emptyString'}, 'store_button')
        const buttonText = UIDStoreBodyController.isRewardAlreadyUnlocked(userReferralCount, referralReward.referralCount) ? UIDStoreBodyController.markAsUnlocked(button, contentDiv) : UIDStoreBodyController.markAsToBeUnlocked(button, referralReward.referralCount)
        return button
    }

    private static createTitleAndImage(headerDiv: HTMLDivElement, bodyDiv: HTMLDivElement, referralReward: ReferralReward): HTMLImageElement {
        const title = createHeaderIn(headerDiv, referralReward.name, '', '', 'H3')
        const titleIcon = createImgIn(title, LobbyImage.InfoIcon)
        const image = createImgIn(bodyDiv, referralReward.image)
        return image
    }

    private static createDescription(bodyDiv: HTMLDivElement, referralReward: ReferralReward): HTMLParagraphElement {
        const description = createParagraphIn(bodyDiv, {key: 'strings:colonistCommon.utils.emptyString'}, '')
        description.style.display = 'none'
        setElementInnerHTML(description, {key: 'strings:colonistCommon.utils.#buffer', options: {value: UIDStoreBodyController.loadReferralItemDescription(referralReward)}})
        return description
    }

    private static addClickEventListener(contentDiv: HTMLDivElement, description: HTMLParagraphElement, image: HTMLImageElement) {
        window.addEventListener('click', (event: MouseEvent) => {
            if(UIDStoreBodyController.isDescriptionAlreadyDisplayed(description)) {
                UIDStoreBodyController.displayImageInsteadOfDescription(description, image)
                return
            }
            if(UIDStoreBodyController.isClickOnTheItem(event, contentDiv)) UIDStoreBodyController.displayDescriptionInsteadOfImage(description, image)
        })
    }

    private static addButtonOnClickBehavior(button: HTMLLinkElement, userReferralCount: number, referralReward: ReferralReward) {
        setElementOnClick(button, () => {
            if(UIDStoreBodyController.isRewardAlreadyUnlocked(userReferralCount, referralReward.referralCount)) return
            AudioManager.play(AudioType.Click)

            DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.ShareActivityLink, {
                message: clientI18n.t('strings:homePage.popups.discordShareActivity.text'),
                referralTypeId: ReferralTypeEnum.ShareActivityReferralProgramStore.toString(),
                analyticsPopupTriggered: referralReward.analyticsPopupTriggered,
                analyticsPopupSuccess: referralReward.analyticsPopupSuccess,
            })
        }, true)
    }

    private static loadReferralItemDescription(referralReward: ReferralReward): string {
        let description = clientI18n.t('strings:storePage.sections.referral.details', {context: referralReward.possibleRewards.length === 1 ? 'one' : 'many'}) + '<br>'
        referralReward.possibleRewards.forEach((possibleReward: BaseStoreItem) => {
            description += `<br>- ${clientI18n.t(possibleReward.name.key)}`
        })
        return description
    }

    private static markAsToBeUnlocked(button: HTMLLinkElement, referralCount: number) {
        createParagraphIn(button, {key: 'strings:storePage.sections.referral.action.toBeUnlocked', options: {referralCount: referralCount, context: referralCount == 1 ? 'one' : 'other'}}, '', '')
    }

    private static markAsUnlocked(button: HTMLLinkElement, contentDiv: HTMLDivElement) {
        createParagraphIn(button, {key: 'strings:storePage.sections.referral.action.unlocked'}, '', '')
        contentDiv.className = 'store_page_item item_owned'
    }

    private static isRewardAlreadyUnlocked(userReferralCount: number, rewardReferralCount: number): boolean {
        if(userReferralCount >= rewardReferralCount) return true
        return false
    }

    private static displayDescriptionInsteadOfImage(description: HTMLParagraphElement, image: HTMLImageElement) {
        description.style.display = 'block'
        image.style.display = 'none'
    }

    private static displayImageInsteadOfDescription(description: HTMLParagraphElement, image: HTMLImageElement) {
        description.style.display = 'none'
        image.style.display = 'block'
    }

    private static isDescriptionAlreadyDisplayed(description: HTMLParagraphElement): boolean {
        return description.style.display == 'block'
    }

    private static isClickOnTheItem(event: MouseEvent, contentDiv: HTMLDivElement): boolean {
        return contentDiv.contains(event.target as Node)
    }
}
